import { useEffect, useRef } from 'preact/hooks';

import { h } from 'preact';
import useMutationObserver from 'utils/mutation-observer';
import { waitForElm } from 'utils/helpers';

const Reviews = ({ id }) => {
  const yotpoRef = useRef(null);
  const technicalDataEl = document.querySelector('[data-technical]');
  const data = JSON.parse(technicalDataEl.textContent);
  const instanceId = data.yotpoBottomlineId;

  const { stop } = useMutationObserver(
    yotpoRef,
    (mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          const reviewsElement = yotpoRef.current.querySelector(
            '.yotpo-sr-bottom-line-text',
          );
          if (reviewsElement) {
            stop();
            const numbersRegex = /\d+/;
            const count = reviewsElement.textContent.match(numbersRegex)[0]
              ? parseInt(reviewsElement.textContent.match(numbersRegex)[0], 10)
              : 0;

            if (!(count > 0)) {
              document
                .querySelectorAll('[data-yotpo-instance-id]')
                .forEach((el) => el.classList.add('!hidden'));
            }
          }
        }
      }
    },
    { childList: true },
  );

  useEffect(() => {
    if (window.yotpoWidgetsContainer?.initWidgets) {
      if (yotpoRef.current) {
        yotpoRef.current.innerHTML = '';
      }
      window.yotpoWidgetsContainer.initWidgets();
    }

    const handleModal = () => {
      if (!document.body.classList.contains('filter-panel-opened')) {
        const { scrollY } = window;
        window.pageScrollOffset = scrollY;
        document.body.style.top = `-${scrollY}px`;
        document.body.classList.add('filter-panel-opened');
      } else {
        document.body.classList.remove('filter-panel-opened');
        document.body.style.top = `0`;
        window.scrollTo(0, window.pageScrollOffset || 0);
      }
    };
    waitForElm('.yotpo-reviews-main-widget.yotpo-main-widget-layout').then(
      (element) => {
        const observer = new MutationObserver((mutations) => {
          if (
            mutations.some((mutation) =>
              [...mutation.addedNodes, ...mutation.removedNodes].some((node) =>
                node.classList?.contains('yotpo-review-form-modal'),
              ),
            )
          ) {
            handleModal();
          }
        });

        observer.observe(element, {
          childList: true,
        });
      },
    );
  }, []);

  return (
    <div
      ref={yotpoRef}
      className="yotpo-widget-instance py-24 border-y border-y-grey-400 mb-32 ml:mb-40"
      data-yotpo-instance-id={instanceId}
      data-yotpo-product-id={id}
      data-yotpo-cart-product-id={id}
      data-yotpo-section-id="product"
    ></div>
  );
};

export default Reviews;
